import React, { useState } from 'react';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is a Smart Home?',
      answer: 'A smart home uses internet-connected devices to enable the remote monitoring and management of appliances and systems, such as lighting and heating.'
    },
    {
      question: 'Why should I invest in a smart home?',
      answer: 'Smart homes offer convenience, energy savings, enhanced security, and improved quality of life through automation and remote control capabilities.'
    },
    {
      question: 'Can you automate my existing home without special wiring?',
      answer: 'Yes! Modern smart home devices use wireless protocols like Wi-Fi, Zigbee, and Z-Wave, making it possible to automate your existing home without extensive rewiring.'
    },
    {
      question: 'What does CLEVR offer?',
      answer: 'CLEVR offers comprehensive smart home solutions including smart lighting, security systems, climate control, entertainment systems, and full home automation compatible with major platforms.'
    },
    {
      question: 'How do I control the system?',
      answer: 'You can control your smart home system through smartphone apps, voice assistants like Alexa and Google Assistant, physical switches, or automated schedules.'
    }
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq" id="faqs">
      <div className="faq-container">
        <span className="section-badge">FREQUENTLY ASKED QUESTIONS</span>
        <h2 className="faq-title">Get All Your Questions Answered</h2>

        <div className="faq-content">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'active' : ''}`}
              >
                <button 
                  className="faq-question"
                  onClick={() => toggleFaq(index)}
                >
                  <span>{faq.question}</span>
                  <svg 
                    className="faq-icon" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth="2" 
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-cta">
            <div className="faq-cta-content">
              <h3>HAVE MORE QUESTIONS?</h3>
              <p>Book a FREE intro call.</p>
              <a href="https://wa.me/+94774641111" className="book-call-btn">
                BOOK A CALL
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
